import { PostCategory } from '@/entities/post-category';
import { axiosAPI } from './axios-instance';
import { ApiRequestFnParams, ApiResponse } from './lib/types';

export type ApiPostCategoriesRequest = Partial<{}>;

export type ApiPostCategoriesResponse = ApiResponse<
    {
        id: number;
        slug: string;
        name: string;
    }[]
>;

export type AppPostCategoriesResponse = ApiResponse<PostCategory[]>;

export const getPostCategories = ({
    params = {},
}: ApiRequestFnParams<ApiPostCategoriesRequest> = {}): Promise<AppPostCategoriesResponse> =>
    axiosAPI.get<ApiPostCategoriesResponse>('/v1/post-categories', { params }).then((res) => res.data);
